/** Količina za prikaz: do tri decimale bez suvišnih nula, po pravilima jezika (0,25 / 0.25), "0" za ništa. */
export const formatQuantity = (value, locale) => {
  const number = Number(value) || 0;
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 3 }).format(number);
};

/** Iznos za prikaz: uvek dve decimale po pravilima jezika (8,00 / 8.00). */
export const formatMoney = (value, locale) => {
  const number = Number(value) || 0;
  return new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(number);
};
